import { render, staticRenderFns } from "./MedicoEletivoComponente.vue?vue&type=template&id=5268e666&scoped=true"
import script from "./MedicoEletivoComponente.vue?vue&type=script&lang=js"
export * from "./MedicoEletivoComponente.vue?vue&type=script&lang=js"
import style0 from "./MedicoEletivoComponente.vue?vue&type=style&index=0&id=5268e666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5268e666",
  null
  
)

export default component.exports